import React, { useEffect } from 'react'
import {IntlProvider} from "react-intl";
import {connect, Provider as ReduxProvider} from "react-redux";
import MainPage from './pages/contents/MainPage'
import translations from './translations'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import LoginPage from './pages/loginPage';
import PrivateRoute from './routes/PrivateRoute';
import {LanguageCode} from "./constants/Enums";
import ResponseObserver from "./hooks/ResponseObserver";
import AlertMessage from "@components/AlertMessage/AlertMessage";
import "./assets/sass/main.sass";
import './App.sass';

function App({lang, user}) {

  return (
    <IntlProvider
            locale={LanguageCode[lang]}
            messages={translations[LanguageCode[lang].toLowerCase()] ? translations[LanguageCode[lang].toLowerCase()] : {}}
            defaultLocale="EN">
        <Router>
          <div>
            <AlertMessage />
            {/* A <Switch> looks through its children <Route>s and
                renders the first one that matches the current URL. */}
            <Switch>
              {!user && <Route path="/">
                <ResponseObserver >
                  <LoginPage />
                </ResponseObserver>
              </Route>}
              <PrivateRoute path="/:all">
                <ResponseObserver >
                  <MainPage />
                </ResponseObserver>
              </PrivateRoute>
              {/* <Route exact path="/:all" render={() => <Redirect to="/"/>}/> */}
              <Route exact path="/" render={() => <Redirect to="dashboard" />}/>
            </Switch>
          </div>
        </Router>
    </IntlProvider>
  );
}

function mapStateToProps(state) {
  return {
      lang: state.settings.lang.id,
      user: state.user
  };
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
